import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContractTypes } from '@shared/services/admin-contract.service';
import { ContractFilters } from '../contracts.component';
import { NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-contracts-filters',
  templateUrl: './contracts-filters.component.html',
  styles: ``,
  imports: [NgSelectComponent, FormsModule, NgFor, NgOptionComponent, TranslatePipe],
})
export class ContractsFiltersComponent {
  @Input({ required: true }) public filterData: ContractFilters;
  @Output() filterDataChange: EventEmitter<ContractFilters> = new EventEmitter<ContractFilters>();
  protected readonly ContractTypes = ContractTypes;

  constructor() {}

  public emitChange() {
    this.filterDataChange.emit({ ...this.filterData });
  }
}
